import ImportEmptyState from 'images/importemptystate.svg'
import React from 'react'

import { Button } from '@driftt/dds'

import './style.css'

const ImportTableEmptyState = () => (
  <div className="import-table-empty-state">
    <img alt="empty-state" src={ImportEmptyState} />
    <h2>Looks like you haven’t imported any contacts yet.</h2>
    <span>Get started by uploading a CSV. Remember, every contact needs an email or userID for us to import them!</span>
    <Button onClick={() => window.open("/contacts/imports/", "_self")}> Upload a CSV </Button>
  </div>
)

export default ImportTableEmptyState
